import React from 'react';
import type { FC } from 'react';
import { SiteAuthProvider } from '@wix/cli-auth';
import { useProjectModel } from '../../model.js';
import { EnvPull } from './EnvPull.js';

export const EnvPullCommand: FC = () => {
  const {
    model: {
      config: { siteId },
    },
  } = useProjectModel();

  return (
    <SiteAuthProvider siteId={siteId}>
      <EnvPull />
    </SiteAuthProvider>
  );
};
